var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModaHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5196 4.03263C29.616 4.16696 30.3959 5.16465 30.2616 6.26102C29.7912 10.0995 29.8163 15.7434 31.5014 20.3278C32.3353 22.5964 33.5378 24.5031 35.1867 25.8386C36.807 27.1509 38.9869 28.0178 41.9994 28.0178C43.104 28.0178 43.9994 28.9132 43.9994 30.0178C43.9994 31.1224 43.104 32.0178 41.9994 32.0178C38.1505 32.0178 35.0616 30.8847 32.6692 28.947C30.3054 27.0325 28.751 24.4391 27.747 21.7078C25.7563 16.2921 25.7813 9.93609 26.2912 5.77455C26.4256 4.67818 27.4233 3.89829 28.5196 4.03263Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9567 30.6663C43.7297 31.7473 42.6693 32.4395 41.5883 32.2125C39.889 31.8555 37.4748 31.8995 35.5657 33.1025C33.7996 34.2154 31.9994 36.6211 31.9994 42.0178C31.9994 43.1223 31.104 44.0178 29.9994 44.0178C28.8949 44.0178 27.9994 43.1223 27.9994 42.0178C27.9994 35.6518 30.1993 31.7562 33.4332 29.7184C36.5241 27.7707 40.1099 27.8146 42.4105 28.2979C43.4915 28.5249 44.1838 29.5853 43.9567 30.6663Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4792 4.03263C18.3829 4.16696 17.603 5.16465 17.7373 6.26102C18.2076 10.0995 18.1826 15.7434 16.4975 20.3278C15.6635 22.5964 14.4611 24.5031 12.8121 25.8386C11.1918 27.1509 9.01199 28.0178 5.99943 28.0178C4.89486 28.0178 3.99943 28.9132 3.99943 30.0178C3.99943 31.1224 4.89486 32.0178 5.99943 32.0178C9.84838 32.0178 12.9372 30.8847 15.3297 28.947C17.6935 27.0325 19.2479 24.4391 20.2519 21.7078C22.2426 16.2921 22.2175 9.93609 21.7076 5.77455C21.5733 4.67818 20.5756 3.89829 19.4792 4.03263Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04214 30.6663C4.2692 31.7473 5.32957 32.4395 6.41055 32.2125C8.10985 31.8555 10.5241 31.8995 12.4332 33.1025C14.1993 34.2154 15.9994 36.6211 15.9994 42.0178C15.9994 43.1223 16.8949 44.0178 17.9994 44.0178C19.104 44.0178 19.9994 43.1223 19.9994 42.0178C19.9994 35.6518 17.7996 31.7562 14.5657 29.7184C11.4748 27.7707 7.88901 27.8146 5.58831 28.2979C4.50733 28.5249 3.81508 29.5853 4.04214 30.6663Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99943 10.0178C3.99943 6.70407 6.68572 4.01778 9.99943 4.01778H37.9994C41.3131 4.01778 43.9994 6.70407 43.9994 10.0178V42.0178C43.9994 43.1224 43.104 44.0178 41.9994 44.0178C40.8949 44.0178 39.9994 43.1224 39.9994 42.0178V10.0178C39.9994 8.91321 39.104 8.01778 37.9994 8.01778H9.99943C8.89486 8.01778 7.99943 8.91321 7.99943 10.0178V42.0178C7.99943 43.1224 7.104 44.0178 5.99943 44.0178C4.89486 44.0178 3.99943 43.1224 3.99943 42.0178V10.0178Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModaHome);
export default __webpack_public_path__ + "static/media/iconModaHome.baa2a843c46399e7868f249304ec4d6b.svg";
export { ForwardRef as ReactComponent };